import React, { createContext, useContext, useEffect, useState } from 'react';
import { toaster } from 'baseui/toast';
import { createAdjustment, getAdjustments } from '@gtintel/platform-api';
import { AdjustmentType } from '@gtintel/platform-types';
import { ProjectContext } from '../../ProjectApp/context';
const defaultAdjustment = {
  adjustment_type: AdjustmentType.client_price,
  amount: 0,
  reason: '',
  actor: 'You',
  created_date: new Date()
};
export const AdjustmentContext = createContext({
  displayedAdjustments: [],
  newAdjustment: defaultAdjustment,
  activeType: AdjustmentType.client_price,
  proposeAdjustment: () => null,
  submitAdjustment: () => null,
  setPriceType: () => null
});
export const AdjustmentProvider = ({
  children
}) => {
  const {
    projectId,
    incrementAdjustmentsCost
  } = useContext(ProjectContext);
  const [adjustments, setAdjustments] = useState([]);
  const [displayedAdjustments, setDisplayedAdjustments] = useState(adjustments);
  const [newAdjustment, setNewAdjustment] = useState(defaultAdjustment);
  const [activeType, setActiveType] = useState(AdjustmentType.client_price);
  useState(() => {
    const updateAdjustments = () => {
      getAdjustments(+projectId()) // TODO: refactor to use `useAsyncOp`
      .then(changes => {
        const results = changes.results.map(a => {
          return {
            ...a,
            created_date: new Date(a.created_date)
          };
        });
        setAdjustments(results);
      }).catch(() => {});
    };
    updateAdjustments();
  });
  useEffect(() => {
    const filteredAdjustments = adjustments.filter(a => a.adjustment_type === activeType);
    if (newAdjustment.amount === 0) {
      setDisplayedAdjustments(filteredAdjustments);
    } else {
      setDisplayedAdjustments([...filteredAdjustments, newAdjustment]);
    }
  }, [newAdjustment, adjustments]);
  const proposeAdjustment = (adjustment, isDiscount) => {
    if (isDiscount && adjustment.amount > 0 || !isDiscount && adjustment.amount < 0) {
      adjustment.amount = -adjustment.amount;
    }
    setNewAdjustment(adjustment);
  };
  const submitAdjustment = () => {
    createAdjustment(+projectId(), newAdjustment) // TODO: refactor to use `useAsyncOp`
    .then(() => {
      setNewAdjustment({
        ...defaultAdjustment,
        adjustment_type: newAdjustment.adjustment_type
      });
      incrementAdjustmentsCost(newAdjustment.amount, newAdjustment.adjustment_type);
      toaster.positive('Adjustment Added');
    }).catch(error => {
      toaster.negative(error.data.reason);
    });
  };
  const setPriceType = type => {
    setActiveType(type);
  };
  return <AdjustmentContext.Provider value={{
    displayedAdjustments,
    activeType,
    newAdjustment,
    proposeAdjustment,
    submitAdjustment,
    setPriceType
  }}>
      {children}
    </AdjustmentContext.Provider>;
};
export const useAdjustments = () => useContext(AdjustmentContext);